import React from 'react';
import {
  Grid,
  Avatar,
  Typography,
  makeStyles,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';
import {Link} from 'react-router-dom';
import api from '../core/api';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {useSnackbar} from 'notistack';
import Confirm from './Confirm';
import {useAppContext} from './singletons/AppContext';

const NewsletterItem = ({newsItem}) => {
  const news = {...newsItem};
  const {enqueueSnackbar} = useSnackbar();
  const {onReloadData} = useAppContext();

  const onDeleteNews = async () => {
    const res = await Confirm('Deseja realmente remover esta Newsletter?');
    if (res)
      try {
        await api.delete(`/newsletter/${news.id}`);
        onReloadData();
        enqueueSnackbar('Deletada com Sucesso!');
      } catch (e) {
        console.log(e);
      }
  };

  

  return (
    <React.Fragment>
      <ListItem alignItems="center">
        <ListItemAvatar>
          <Avatar alt="Remy Sharp" style={{textTransform: 'uppercase'}}>
            {(news.subject || '')[0].toUpperCase()}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={news.subject}
          secondary={
            <Grid container>
              {/* <Grid item xs={5}>
                <ListItemIcon>
                  <Typography
                    variant="body1"
                    className="flex-row center-b"
                    color="textPrimary">
                    <>
                      {news.usersType.length > 0 &&
                        news.usersType.map(c => (
                          <Typography
                            variant="body2"
                            className="flex-row center-b"
                            color="textPrimary">{` | Plano ${ReturnTypePremium(
                            c.usersType,
                          )} `}</Typography>
                        ))}
                    </>
                  </Typography>
                </ListItemIcon>
              </Grid> */}
              <Grid item xs={2}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Status: {news.status === 'Active' ? 'Ativo' : 'Inativo'}
                  </Typography>
                </ListItemIcon>
              </Grid>
            </Grid>
          }
        />
        <ListItemSecondaryAction>
          <IconButton
            component={Link}
            to={`/newsletter/edit/${news.id}`}
            edge="end">
            <EditIcon />
          </IconButton>
          <IconButton onClick={onDeleteNews} edge="end">
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </React.Fragment>
  );
};
export default NewsletterItem;

export function ReturnTypePremium(premium) {
  switch (premium) {
    case 'F':
      return 'Free';
    case 'N':
      return 'New';
    case 'M':
      return 'Mensal';
    case 'Y':
      return 'Anual';
    default:
      return 'Indefinido';
  }
}
